import stylusConfig from '@pb/kit-stylus/config.json';

/**
 * The `convertPxToRem` is util that used to convert a value in pixels to a value in rem
 * @param px Value in pixels
 * @param default_px Default value
 * @returns {string|null}
 */
export function convertPxToRem(
    px: number,
    default_px?: number
): string;
export function convertPxToRem(
    px: null | undefined,
    default_px?: number
): null;

export function convertPxToRem(
    px: number | null | undefined,
    default_px = stylusConfig.font.baseFont,
) {
    return px ? String(px / default_px) + 'rem' : null;
}
